module.exports = __webpack_public_path__ + "static/media/cross.e0891a92.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icons/cross.svg
// module id = 268
// module chunks = 0